import React from "react";
import { withRouter, Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faEllipsisV,
    faTable,
    faCaretUp,
} from "@fortawesome/free-solid-svg-icons";
import Table from "react-bootstrap/Table";
class Developer3 extends React.Component {
    render() {
        return (
            <div className="container-fluid developer">
                <div className="row mb-4">
                    <div class="col-lg-3 mb-4">
                        <div class="widget widgetCard">
                            <div class="row">
                                <div class="col-lg-4 flexCenter">
                                    <img
                                        alt="Current Coverage Icon"
                                        src="/edge/images/total_office_stock_built.png"
                                        class="imgWidth100"
                                    />
                                </div>
                                <div class="col-lg-8 text-start colorLightBlue">
                                    <h1>29.1 msf</h1>
                                    <p>(21 Assets)</p>
                                    <p class="widgetName">Total Office Stock Built</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 mb-4">
                        <div class="widget widgetCard">
                            <div class="row">
                                <div class="col-lg-4 flexCenter">
                                    <img
                                        alt="Current Vacancy Icon"
                                        src="/edge/images/updated_logos/underconstructiion.svg"
                                        class="imgWidth100"
                                    />
                                </div>
                                <div class="col-lg-8 text-start colorDarkBlue">
                                    <h1>23 %</h1>
                                    <p>(34 msf)</p>
                                </div>
                            </div>
                            <p class="widgetName">Current Vacancy</p>
                        </div>
                    </div>
                    <div class="col-lg-3 mb-4">
                        <div class="widget widgetCard">
                            <div class="row">
                                <div class="col-lg-4 flexCenter">
                                    <img
                                        alt="Current Passing Rent Icon"
                                        src="/edge/images/current_coverage.png"
                                        class="imgWidth100"
                                    />
                                </div>
                                <div class="col-lg-8 text-start colorLightBlue">
                                    <h1>
                                        ₹71 <span class="smallText"> sqft/month</span>
                                    </h1>
                                </div>
                            </div>
                            <p class="widgetName">Current Passing Rent</p>
                        </div>
                    </div>
                    <div class="col-lg-3 mb-4">
                        <div class="widget widgetCard">
                            <div class="row">
                                <div class="col-lg-4 flexCenter">
                                    <img
                                        alt="Current Vacancy Icon"
                                        src="/edge/images/current_vacancy.png"
                                        class="imgWidth100"
                                    />
                                </div>
                                <div class="col-lg-8 text-start colorDarkBlue">
                                    <h1>7.1 msf</h1>
                                    <p>(191 Assets)</p>
                                </div>
                            </div>
                            <p class="widgetName">Upcoming Supply - 36 months</p>
                        </div>
                    </div>
                    <div class="col-lg-3 mb-4">
                        <div class="widget widgetCard">
                            <div class="row">
                                <div class="col-lg-4 flexCenter">
                                    <img
                                        alt="Current Coverage Icon"
                                        src="/edge/images/occupiers.png"
                                        class="imgWidth100"
                                    />
                                </div>
                                <div class="col-lg-8 text-start colorLightBlue">
                                    <h1>529 msf</h1>
                                    {/* <p>(729 Micro-markets)</p> */}
                                </div>
                            </div>
                            <p class="widgetName">Total Office Stock Built</p>
                        </div>
                    </div>
                    <div class="col-lg-3 mb-4">
                        <div class="widget widgetCard">
                            <div class="row">
                                <div class="col-lg-4 flexCenter">
                                    <img
                                        alt="Current Vacancy Icon"
                                        src="/edge/images/current_passing_rent.png"
                                        class="imgWidth100"
                                    />
                                </div>
                                <div class="col-lg-8 text-start colorDarkBlue">
                                    <h1>23 %</h1>
                                    <p>(34 msf)</p>
                                </div>
                            </div>
                            <p class="widgetName">Current Vacancy</p>
                        </div>
                    </div>
                    <div class="col-lg-3 mb-4">
                        <div class="widget widgetCard">
                            <div class="row">
                                <div class="col-lg-4 flexCenter">
                                    <img
                                        alt="Current Passing Rent Icon"
                                        src="/edge/images/wale.png"
                                        class="imgWidth100"
                                    />
                                </div>
                                <div class="col-lg-8 text-start colorLightBlue">
                                    <h1>
                                        ₹71 <span class="smallText"> sqft/month</span>
                                    </h1>
                                </div>
                            </div>
                            <p class="widgetName">Current Passing Rent</p>
                        </div>
                    </div>
                    <div class="col-lg-3 mb-4">
                        <div class="widget widgetCard">
                            <div class="row">
                                <div class="col-lg-4 flexCenter">
                                    <img
                                        alt="Current Vacancy Icon"
                                        src="/edge/images/re-leasing.png"
                                        class="imgWidth100"
                                    />
                                </div>
                                <div class="col-lg-8 text-start colorDarkBlue">
                                    <h1>7.1 msf</h1>
                                    <p>(191 Assets)</p>
                                </div>
                            </div>
                            <p class="widgetName">Upcoming Supply - 36 months</p>
                        </div>
                    </div>
                </div>
                <div className="row mb-4">
                    <div className="col-lg-8">
                        <div className="widget widgetGraph">
                            <div className="row">
                                <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
                                    <p>Top Developers - Built Stock</p>
                                    <h4 className="colorGreen">
                                        <FontAwesomeIcon icon={faCaretUp} size="lg" />
                                        14%
                                    </h4>
                                    <p className="colorBlack pSmall">M-o-m vs Q1 CY’19</p>
                                </div>
                                <div className="col-lg-3 text-end">
                                    <Link to="/#">
                                        <FontAwesomeIcon icon={faTable} />
                                    </Link>
                                    <Link to="/#" className="colorBlack">
                                        <FontAwesomeIcon icon={faEllipsisV} />
                                    </Link>
                                </div>
                                <div className="col-lg-12">
                                    {/* <Bar
                        options={this.state.chartOtions}
                        data={this.state.chartData}
                      /> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className="widget widgetTable">
                            <div className="row">
                                <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
                                    <p>Top 10 Occupiers</p>
                                </div>
                                <div className="col-lg-12 mt-2">
                                    <Table responsive hover>
                                        <thead>
                                            <tr className="">
                                                <th>Developer</th>
                                                <th>Built Stock(#)</th>
                                                <th>Built Stock(msf)</th>
                                                <th className="text-end">Occupancy(%)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr className="">
                                                <td>Accenture</td>
                                                <td>IT/ITeS</td>
                                                <td>1.1 msf(7%)</td>
                                                <td>INR 92 Cr. (10%)</td>
                                            </tr>
                                            <tr className="">
                                                <td>Accenture</td>
                                                <td>IT/ITeS</td>
                                                <td>1.1 msf(7%)</td>
                                                <td>INR 92 Cr. (10%)</td>
                                            </tr>
                                            <tr className="">
                                                <td>Accenture</td>
                                                <td>IT/ITeS</td>
                                                <td>1.1 msf(7%)</td>
                                                <td>INR 92 Cr. (10%)</td>
                                            </tr>
                                            <tr className="">
                                                <td>Accenture</td>
                                                <td>IT/ITeS</td>
                                                <td>1.1 msf(7%)</td>
                                                <td>INR 92 Cr. (10%)</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mb-4">
                    <div className="col-lg-6">
                        <div className="widget widgetGraph">
                            <div className="row">
                                <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
                                    <p>Passing Rent and Market Rent</p>
                                    <h4 className="colorGreen">
                                        <FontAwesomeIcon icon={faCaretUp} size="lg" />
                                        14%
                                    </h4>
                                    <p className="colorBlack pSmall">M-o-m vs Q1 CY’19</p>
                                </div>
                                <div className="col-lg-3 text-end">
                                    <Link to="/#">
                                        <FontAwesomeIcon icon={faTable} />
                                    </Link>
                                    <Link to="/#" className="colorBlack">
                                        <FontAwesomeIcon icon={faEllipsisV} />
                                    </Link>
                                </div>
                                <div className="col-lg-12">
                                    {/* <Bar
                        options={this.state.chartOtions}
                        data={this.state.chartData}
                      /> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="widget widgetGraph">
                            <div className="row">
                                <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
                                    <p>Future Rent, Rent Escalations & Occupiers</p>
                                </div>
                                <div className="col-lg-3 text-end">
                                    <Link to="/#">
                                        <FontAwesomeIcon icon={faTable} />
                                    </Link>
                                    <Link to="/#" className="colorBlack">
                                        <FontAwesomeIcon icon={faEllipsisV} />
                                    </Link>
                                </div>
                                <div className="col-lg-12">
                                    {/* <Bar
                        options={this.state.chartOtions}
                        data={this.state.chartData}
                      /> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mb-4">
                    <div className="col-lg-12">
                        <div className="widget widgetTable">
                            <div className="row">
                                <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
                                    <p>Top Assets of Brookfield</p>
                                </div>
                                <div className="col-lg-12 mt-2">
                                    <Table responsive hover>
                                        <thead>
                                            <tr className="">
                                                <th>Asset</th>
                                                <th>Year Built/Acquired</th>
                                                <th>Leasable Area</th>
                                                <th># of Buildings</th>
                                                <th># of Tenants</th>
                                                <th>Passing Rent</th>
                                                <th>Market Rent</th>
                                                <th>WALE</th>
                                                <th>Occupancy</th>
                                                <th>Valuation*</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr className="">
                                                <td>Aster</td>
                                                <td>1992</td>
                                                <td>7.2</td>
                                                <td>3</td>
                                                <td>32</td>
                                                <td>96</td>
                                                <td>112</td>
                                                <td>61</td>
                                                <td>92%</td>
                                                <td>9,538 Cr.</td>
                                            </tr>
                                            <tr className="">
                                                <td>Aster</td>
                                                <td>1992</td>
                                                <td>7.2</td>
                                                <td>3</td>
                                                <td>32</td>
                                                <td>96</td>
                                                <td>112</td>
                                                <td>61</td>
                                                <td>92%</td>
                                                <td>9,538 Cr.</td>
                                            </tr>
                                            <tr className="">
                                                <td>Aster</td>
                                                <td>1992</td>
                                                <td>7.2</td>
                                                <td>3</td>
                                                <td>32</td>
                                                <td>96</td>
                                                <td>112</td>
                                                <td>61</td>
                                                <td>92%</td>
                                                <td>9,538 Cr.</td>
                                            </tr>
                                            <tr className="">
                                                <td>Aster</td>
                                                <td>1992</td>
                                                <td>7.2</td>
                                                <td>3</td>
                                                <td>32</td>
                                                <td>96</td>
                                                <td>112</td>
                                                <td>61</td>
                                                <td>92%</td>
                                                <td>9,538 Cr.</td>
                                            </tr>
                                            <tr className="">
                                                <td>Aster</td>
                                                <td>1992</td>
                                                <td>7.2</td>
                                                <td>3</td>
                                                <td>32</td>
                                                <td>96</td>
                                                <td>112</td>
                                                <td>61</td>
                                                <td>92%</td>
                                                <td>9,538 Cr.</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mb-4">
                    <div className="col-lg-6">
                        <div className="widget widgetGraph">
                            <div className="row">
                                <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
                                    <p>Area Leased - Transaction Size</p>
                                </div>
                                <div className="col-lg-3 text-end">
                                    <Link to="/#">
                                        <FontAwesomeIcon icon={faTable} />
                                    </Link>
                                    <Link to="/#" className="colorBlack">
                                        <FontAwesomeIcon icon={faEllipsisV} />
                                    </Link>
                                </div>
                                <div className="col-lg-12">
                                    {/* <Bar
                        options={this.state.chartOtions}
                        data={this.state.chartData}
                      /> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="widget widgetGraph">
                            <div className="row">
                                <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
                                    <p>Area Leased - Transaction Size</p>
                                </div>
                                <div className="col-lg-3 text-end">
                                    <Link to="/#">
                                        <FontAwesomeIcon icon={faTable} />
                                    </Link>
                                    <Link to="/#" className="colorBlack">
                                        <FontAwesomeIcon icon={faEllipsisV} />
                                    </Link>
                                </div>
                                <div className="col-lg-12">
                                    {/* <Bar
                        options={this.state.chartOtions}
                        data={this.state.chartData}
                      /> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mb-4">
                    <div className="col-lg-6">
                        <div className="widget widgetGraph tableBlue">
                            <div className="row">
                                <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
                                    <p>Upcomming Supply</p>
                                </div>
                                <div className="col-lg-3 text-end">
                                    <Link to="/#">
                                        <FontAwesomeIcon icon={faTable} />
                                    </Link>
                                    <Link to="/#" className="colorBlack">
                                        <FontAwesomeIcon icon={faEllipsisV} />
                                    </Link>
                                </div>
                                <div className="col-lg-12">
                                    {/* <Bar
                        options={this.state.chartOtions}
                        data={this.state.chartData}
                      /> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="widget widgetGraph">
                            <div className="row">
                                <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
                                    <p>City-wise Presence</p>
                                </div>
                                <div className="col-lg-3 text-end">
                                    <Link to="/#">
                                        <FontAwesomeIcon icon={faTable} />
                                    </Link>
                                    <Link to="/#" className="colorBlack">
                                        <FontAwesomeIcon icon={faEllipsisV} />
                                    </Link>
                                </div>
                                <div className="col-lg-12">
                                    {/* <Bar
                        options={this.state.chartOtions}
                        data={this.state.chartData}
                      /> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mb-4">
                    <div className="col-lg-6">
                        <div className="widget widgetGraph">
                            <div className="row">
                                <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
                                    <p>Sector Break-up of Area Occupied</p>
                                </div>
                                <div className="col-lg-3 text-end">
                                    <Link to="/#">
                                        <FontAwesomeIcon icon={faTable} />
                                    </Link>
                                    <Link to="/#" className="colorBlack">
                                        <FontAwesomeIcon icon={faEllipsisV} />
                                    </Link>
                                </div>
                                <div className="col-lg-12">
                                    {/* <Bar
                        options={this.state.chartOtions}
                        data={this.state.chartData}
                      /> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="widget widgetGraph">
                            <div className="row">
                                <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
                                    <p>Sector-wise Rent</p>
                                    <h4 className="colorGreen">
                                        <FontAwesomeIcon icon={faCaretUp} size="lg" />
                                        BFSI - 14%
                                    </h4>
                                    <p className="colorBlack pSmall">Y-o-y vs CY’21</p>
                                </div>
                                <div className="col-lg-3 text-end">
                                    <Link to="/#">
                                        <FontAwesomeIcon icon={faTable} />
                                    </Link>
                                    <Link to="/#" className="colorBlack">
                                        <FontAwesomeIcon icon={faEllipsisV} />
                                    </Link>
                                </div>
                                <div className="col-lg-12">
                                    {/* <Bar
                        options={this.state.chartOtions}
                        data={this.state.chartData}
                      /> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mb-4">
                    <div className="col-lg-12">
                        <div className="widget widgetTable">
                            <div className="row">
                                <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
                                    <p>Major Recent Transactions</p>
                                </div>
                                <div className="col-lg-12 mt-2">
                                    <Table responsive hover>
                                        <thead>
                                            <tr className="">
                                                <th>Tenant</th>
                                                <th>New/Renewal</th>
                                                <th>Date</th>
                                                <th>Complex</th>
                                                <th>Chargeable Area (Sqft)</th>
                                                <th>Rent (₹/Sqft/Month)</th>
                                                <th>Micro-Market</th>
                                                <th>City</th>
                                                <th>Term</th>
                                                <th>Security Deposit*</th>
                                                <th>CAM</th>
                                                <th>1st Escalation %</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr className="">
                                                <td>Aster</td>
                                                <td>1992</td>
                                                <td>7.2</td>
                                                <td>3</td>
                                                <td>32</td>
                                                <td>96</td>
                                                <td>112</td>
                                                <td>61</td>
                                                <td>92%</td>
                                                <td>9,538 Cr.</td>
                                                <td>92%</td>
                                                <td>9,538 Cr.</td>
                                            </tr>
                                            <tr className="">
                                                <td>Aster</td>
                                                <td>1992</td>
                                                <td>7.2</td>
                                                <td>3</td>
                                                <td>32</td>
                                                <td>96</td>
                                                <td>112</td>
                                                <td>61</td>
                                                <td>92%</td>
                                                <td>9,538 Cr.</td>
                                                <td>92%</td>
                                                <td>9,538 Cr.</td>
                                            </tr>
                                            <tr className="">
                                                <td>Aster</td>
                                                <td>1992</td>
                                                <td>7.2</td>
                                                <td>3</td>
                                                <td>32</td>
                                                <td>96</td>
                                                <td>112</td>
                                                <td>61</td>
                                                <td>92%</td>
                                                <td>9,538 Cr.</td>
                                                <td>92%</td>
                                                <td>9,538 Cr.</td>
                                            </tr>
                                            <tr className="">
                                                <td>Aster</td>
                                                <td>1992</td>
                                                <td>7.2</td>
                                                <td>3</td>
                                                <td>32</td>
                                                <td>96</td>
                                                <td>112</td>
                                                <td>61</td>
                                                <td>92%</td>
                                                <td>9,538 Cr.</td>
                                                <td>92%</td>
                                                <td>9,538 Cr.</td>
                                            </tr>
                                            <tr className="">
                                                <td>Aster</td>
                                                <td>1992</td>
                                                <td>7.2</td>
                                                <td>3</td>
                                                <td>32</td>
                                                <td>96</td>
                                                <td>112</td>
                                                <td>61</td>
                                                <td>92%</td>
                                                <td>9,538 Cr.</td>
                                                <td>92%</td>
                                                <td>9,538 Cr.</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(Developer3);
